/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Partner_Customer_Invite_UnapprovedInputs */



/**
* | output |
* | --- |
* | "This contract has not been approved yet. Once oneAI approves it, the administrator is emailed an invitation when the term begins on {date} — or straight away..." |
*
* @param {Partner_Customer_Invite_UnapprovedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_customer_invite_unapproved = /** @type {((inputs: Partner_Customer_Invite_UnapprovedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Customer_Invite_UnapprovedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Dieser Vertrag wurde noch nicht genehmigt. Sobald oneAI ihn genehmigt, erhält die Administratorin oder der Administrator zum Laufzeitbeginn am ${i?.date} eine Einladung per E-Mail — oder sofort, wenn dieses Datum schon erreicht ist.`)
	return /** @type {LocalizedString} */ (`This contract has not been approved yet. Once oneAI approves it, the administrator is emailed an invitation when the term begins on ${i?.date} — or straight away if that date has already come.`)
});